import List from './components/List'
import Form from './components/Form'

export default [
  {path: '/place', component: List, name: 'place.index'},
  {path: '/place/store', component: Form, name: 'place.store'},
  {path: '/place/:id', component: Form, name: 'place.update'}
]



// WEBPACK FOOTER //
// ./src/app/domains/place/routes.js